<template>
  <v-form>
    <v-card>
      <v-card-title>
        <span class="headline">View / Edit Host Club {{club.clubName}}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedClub.clubName" label="Club Name" ></v-text-field>
            </v-col>
            <v-col cols="12" sm="5">
              <v-select v-model="editedClub.clubRep" label="Managed by" :disabled=repLocked :items="hosts"></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedClub.webSite" label="Web Site"></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="reset">Reset</v-btn>
        <v-btn color="blue darken-1" text @click="close">Close</v-btn>
        <v-btn color="blue darken-1" text @click="save">Save</v-btn>
      </v-card-actions>

    </v-card>
  </v-form>
</template>

<script>

export default {
  components: {
  },
  name: "ClubDetail",
  mounted: function () {
    if (this.$usrStore.token == null) {
      if (localStorage.getItem('token') !== 'undefined') {
        if (localStorage.getItem('token').length > 4) {
          this.$initFromToken(localStorage.getItem('token'))
        }
      }
    }
    //this.loadUser()
    this.editedClub = Object.assign(this.editedClub, this.club)
  },
  data: () => ({
    editedClub: {
      clubName: '',
      clubRep: {
        mNbr: '',
        id: 0,
        fullName: ''
      },
      extra: {},
      webSite: '',
    }
  }),
  props: {
    club: {
      type: Object,
      default: null
    },
    hosts: [],
  },
  watch: {
    club(newClub) {
      console.log('watch->newClub')
      console.log(newClub)
      this.editedClub = Object.assign(this.editedClub, newClub)
    },
  },
  methods: {
    close: function () {
      this.reset()
      this.$emit('endClubDetail', null)
    },
    reset: function () {
      this.editedClub = Object.assign(this.editedClub, this.club)
    },
    save: async function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true
      try {
        const resp = await this.$http.post(this.$remote + '/api.host/updhost', {
          token: theToken,
          updated: this.editedClub,
        })

        for( let i=0; i < this.hosts.length; i++) {
          if (this.hosts[i].id == this.editedClub.clubRep) {
            this.editedClub.rep = Object.assign(this.editedClub.rep, this.hosts[i])
          }
        }
        this.editedClub = Object.assign(resp.data.updated)

      } catch (e) {
        alert(e)
        return
      }
      this.club = Object.assign(this.club, this.editedClub)
      this.$emit('endClubDetail', null)
    },
  },
  computed: {
    isValid () {
      return (this.selectedDog !== {})
    },
    repLocked () {
      if (this.$hasRole(['adm','sys'])) {
        return false
      }
      if (this.$usrStore.id == this.club.clubRep) {
        return false
      }
      return true
    }
  }
}
</script>